import { ApiResponse, KiteCredentials,  ProviderConnection, ProviderType } from "@ocktra/shared-types"
import { apiClient } from "../../api"

export const connectToKite=async(credentials:KiteCredentials,providerType:ProviderType):Promise<ProviderConnection>=>{
    if(!credentials.apiKey || !credentials.apiSecret){
        throw new Error('Missing required Kite credentials');
    }

    try{
        const response = await apiClient.post<ApiResponse<ProviderConnection>>('/provider/connect', {
            providerName: 'kite',
            providerType,
            credentials
        })

        if(!response.success){
            throw new Error(response.message);
        }

        return response.data!;

    }catch(err){
        console.error('Kite connection error:', err);
        throw new Error('Failed to connect to Kite provider');
    }

}

